import alert from '@/plugins/alert'
import { Facility } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    facilities: {},
    count: 0
  },
  actions: {
    async fetchFacilities({ commit }, options) {
      commit(
        'setFacilities',
        await Facility.fetch({ ...options, _sort: 'createdAt:DESC' })
      )
    },
    async countFacilities({ commit }, options) {
      commit('setCount', await Facility.count(options))
    },
    async fetchFacility({ commit }, facilityId) {
      commit('setFacility', await Facility.fetchOne(facilityId))
    },
    // api is create or update. If record exist then create.
    async createFacility({ commit }, { data, options }) {
      commit('setFacility', await Facility.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async updateFacility({ commit, state }, { id, ...facility }) {
      commit('setFacility', await Facility.update(id, facility))
      alert.success('Cập nhật thành công!')
    },
    async removeFacility({ commit }, id) {
      await Facility.remove(id)
      commit('removeFacility', id)
      alert.success('Xóa thành công!')
    },
    setFacility({ commit, state }, facility) {
      commit('setFacility', facility)
    },
    async removeFacilities({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeFacility', item.id)
      }
    },
    async updateFacilities({ dispatch }, items) {
      await Promise.all(items.map(item => dispatch('updateFacility', item)))
    }
  },
  mutations: {
    setFacilities(state, facilities) {
      state.facilities = facilities.reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue.id]: currentValue
        }),
        {}
      )
    },
    setFacility(state, facility) {
      state.facilities = {
        ...state.facilities,
        [facility.id]: facility
      }
    },
    removeFacility(state, facilityId) {
      delete state.facilities[facilityId]
      state.facilities = { ...state.facilities }
    },
    setCount(state, count) {
      state.count = count
    }
  },
  getters: {
    facilities: state => {
      return Object.values(state.facilities)
    },
    facility: state => id => {
      return state.facilities[id]
    },
    count: state => {
      return state.count
    }
  }
}
